import { render, staticRenderFns } from "./addActivityPlan.vue?vue&type=template&id=a28094d6&scoped=true"
import script from "./addActivityPlan.vue?vue&type=script&lang=js"
export * from "./addActivityPlan.vue?vue&type=script&lang=js"
import style0 from "./addActivityPlan.vue?vue&type=style&index=0&id=a28094d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28094d6",
  null
  
)

export default component.exports